/* eslint-disable camelcase */
import indexOf from 'ramda/src/indexOf'

export default function modelFocalLengthSelector({ focal_lengths, aovs }, chosenAov) {
  const fLength = focal_lengths.length
  const aLength = aovs.length

  if (!fLength) return []
  if (aLength === 0 && fLength) return focal_lengths[0]
  if (fLength !== aLength) return focal_lengths[0]
  if (!chosenAov && fLength) return focal_lengths[0]
  return focal_lengths[indexOf(chosenAov, aovs)]
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/modelFocalLengthSelector.js